var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cooperateEdit,
                expression: "cooperateEdit"
              }
            ],
            staticClass: "triggers"
          },
          [
            _c("cargo-button-group-slider", [
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        type: "primary",
                        disabled: _vm.readonly
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.addBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Add2")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "2",
                        type: "danger",
                        disabled: _vm.readonly
                      },
                      on: {
                        click: function($event) {
                          return _vm.pm.delBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "3", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.pm.downTemplateBtn_clickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.TemplateDownload")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "padding-left": "5px"
                      },
                      attrs: {
                        disabled: _vm.readonly,
                        action: _vm.URL.seaExport.poItemsImportExcel,
                        headers: { sessionId: _vm.user.sessionId },
                        data: { jobUuid: _vm.job.uuid, jobNo: _vm.job.jobNo },
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "before-upload": _vm.beforeUpload,
                        "on-success": _vm.uploadSuccess
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", disabled: _vm.readonly } },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelImport")))]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "4", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.pm.exportBtnClickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ExcelExport")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "5", type: "success" },
                      on: {
                        click: function($event) {
                          return _vm.pm.onBatchPrint()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "6", type: "primary", disabled: _vm.isEdit },
                      on: {
                        click: function($event) {
                          return _vm.pm.relatedContainerHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AddPackingInfo")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "7", type: "primary", disabled: _vm.isEdit },
                      on: {
                        click: function($event) {
                          return _vm.pm.removeRelatedContainerHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.RemovePackingInfo")))]
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "100%" },
            attrs: {
              "config-module": "130122",
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.gridParams,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.poItems,
              "wrap-text": true
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c("trade-detail-container-linked-dialog", {
        attrs: {
          visible: _vm.tradeDetailContainerLinkedDialog.visible,
          job: _vm.job,
          "sel-po-items": _vm.tradeDetailContainerLinkedDialog.selPoItems,
          "related-container-usage":
            _vm.tradeDetailContainerLinkedDialog.relatedContainerUsage
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(
              _vm.tradeDetailContainerLinkedDialog,
              "visible",
              $event
            )
          },
          linkUsagesEventHandler: _vm.linkUsagesEventHandler
        }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }